// extracted by mini-css-extract-plugin
export default {"form":"CreateFolderForm_form__8IHxe"};